// API Endpoints
export const API_ENDPOINTS = {
  // Health
  HEALTH: '/health',
  
  // Stays
  STAYS: '/api/stays',
  STAYS_PAW_STORIES: '/api/stays/paw-stories',
  STAYS_SPOTLIGHT: '/api/stays/spotlight',
  STAYS_SEARCH: '/api/stays/search',
  STAYS_CITIES: '/api/stays/cities',
  STAYS_BY_ID: (id) => `/api/stays/${id}`,
  
  // Events
  EVENTS: '/api/events',
  EVENTS_SEARCH: '/api/events/search',
  EVENTS_BY_ID: (id) => `/api/events/${id}`,
  EVENT_SHOWS: (eventId) => `/api/events/${eventId}/shows`,
  EVENT_DATES: (eventId) => `/api/events/${eventId}/dates`,
  EVENT_TICKETS: (eventId, showId) => `/api/events/${eventId}/shows/${showId}/tickets`,
  
  // Auth
  AUTH_SEND_OTP: '/api/auth/send-otp',
  AUTH_VERIFY_OTP: '/api/auth/verify-otp',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_LOGOUT: '/api/auth/logout',
  
  // Users
  USERS: '/api/users',
  USERS_BY_ID: (id) => `/api/users/${id}`,
  USERS_PROFILE: '/api/users/profile',
  
  // Bookings
  BOOKINGS: '/api/bookings',
  BOOKINGS_BY_ID: (id) => `/api/bookings/${id}`,
  
  // Payments
  PAYMENTS: '/api/payments',
  PAYMENTS_BY_ID: (id) => `/api/payments/${id}`,
  
  // Inventory
  INVENTORY: '/api/inventory',
  INVENTORY_AVAILABILITY: '/api/inventory/availability',
  INVENTORY_CHECK_AVAILABILITY: '/api/inventory/check-availability',
};

// API Configuration
export const API_CONFIG = {
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error - please check your connection',
  SERVER_ERROR: 'Server error - please try again later',
  UNAUTHORIZED: 'Please login to continue',
  FORBIDDEN: 'You don\'t have permission to access this resource',
  NOT_FOUND: 'The requested resource was not found',
  VALIDATION_ERROR: 'Please check your input and try again',
  TIMEOUT_ERROR: 'Request timed out - please try again',
  UNKNOWN_ERROR: 'Something went wrong - please try again',
};

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 20,
  DEFAULT_OFFSET: 0,
  MAX_LIMIT: 100,
}; 